/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2022/05/31
 * @created by      :   ANS356 – a-tsukida@ans-net.co.jp
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) ANS
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
const ra400100v = () => import('@/views/faq/ra400100v');
const ra400200v = () => import('@/views/faq/ra400200v');
const ra400300v = () => import('@/views/faq/ra400300v');
const ra400500v = () => import('@/views/faq/ra400500v');
const ra400700v = () => import('@/views/faq/ra400700v');
const ra400800v = () => import('@/views/faq/ra400800v');
const ra400101i = () => import('@/views/faq/ra400101i');
const ra400201i = () => import('@/views/faq/ra400201i');
const ra400301i = () => import('@/views/faq/ra400301i');
const ra400400i = () => import('@/views/faq/ra400400i');
const ra400600i = () => import('@/views/faq/ra400600i');

/**
 * Defined Router
 */
export default [
    {
        path: '/faq/ra400100v',
        name: 'ra400100v',
        component: ra400100v,
        meta: {
            title: 'よくある質問',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400200v',
        name: 'ra400200v',
        component: ra400200v,
        meta: {
            title: 'よくある質問',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400300v',
        name: 'ra400300v',
        component: ra400300v,
        meta: {
            title: 'よくある質問',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400500v',
        name: 'ra400500v',
        component: ra400500v,
        meta: {
            title: '問合せ一覧'
        }
    },
    {
        path: '/faq/ra400700v',
        name: 'ra400700v',
        component: ra400700v,
        meta: {
            title: '過去質問一覧',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400800v',
        name: 'ra400800v',
        component: ra400800v,
        meta: {
            title: '過去質問の閲覧',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400101i',
        name: 'ra400101i',
        component: ra400101i,
        meta: {
            title: 'よくある質問'
        }
    },
    {
        path: '/faq/ra400201i',
        name: 'ra400201i',
        component: ra400201i,
        meta: {
            title: 'よくある質問'
        }
    },
    {
        path: '/faq/ra400301i',
        name: 'ra400301i',
        component: ra400301i,
        meta: {
            title: 'よくある質問'
        }
    },
    {
        path: '/faq/ra400400i',
        name: 'ra400400i',
        component: ra400400i,
        meta: {
            title: '質問',
            isClientPage: true
        }
    },
    {
        path: '/faq/ra400600i',
        name: 'ra400600i',
        component: ra400600i,
        meta: {
            title: '質問への回答'
        }
    }
];
